var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { getBook, searchBooks, submitMissingBook } from '../utils/api/bookApi';
import { getQueryParamByName } from '../utils/urlDecoder';
import './SearchPage.less';
var SEARCH_LIMIT = 30;
var PAGE_LIMIT = 999;
var getSearchQuery = function () { return (getQueryParamByName('query') || getQueryParamByName('ean') || ''); };
var getPage = function () {
    var page = parseInt(getQueryParamByName('page') || '0', 10);
    if (Number.isNaN(page) || page < 0) {
        return 0;
    }
    return Math.min(page, PAGE_LIMIT);
};
var stripIsbn = function (query) { return query.replace(/[- ]/g, ''); };
var isMissingBookCandidate = function (query) { return /^\d{10}$|^\d{13}$/.test(stripIsbn(query)); };
var getSearchPath = function (query, page) { return ("/sok?query=" + encodeURIComponent(query) + "&page=" + page); };
var formatPrice = function (price) {
    if (price === null || price === undefined) {
        return 'Ingen annonser';
    }
    if (Number(price) === 0) {
        return 'Gis bort!';
    }
    return "Fra " + Number(price).toLocaleString('nb-NO') + ",-";
};
var formatMetadata = function (book) { return [
    "ISBN " + book.isbn,
    book.publishedYear,
    book.edition ? book.edition + ". utgave" : null,
    book.authors.length > 0 ? book.authors.join(', ') : null,
].filter(Boolean).join(', '); };
var SearchTips = function (_a) {
    var query = _a.query, _b = _a.tooShort, tooShort = _b === void 0 ? false : _b, _c = _a.missingSaved, missingSaved = _c === void 0 ? false : _c;
    return (React.createElement("div", { className: "main-content search-page__empty" },
        React.createElement("h1", null, "Ingen resultater"),
        React.createElement("p", null,
            query ? "Ditt s\u00F8k etter '" + query + "' gav ingen resultater." : 'Du søkte med tomt søkefelt og fikk derfor ingen resultat.',
            ' ',
            tooShort && 'Søkestrengen er for kort. Du må ha minst 3 tegn i søkestrengen.',
            !tooShort && missingSaved && "Vi har registrert at du ikke fant boken med s\u00F8keord/ISBN \"" + query + "\".",
            !tooShort && !missingSaved && 'Prøv på nytt.'),
        React.createElement("section", null,
            React.createElement("h2", null, "S\u00F8ketips"),
            React.createElement("p", null, "Husk at du kan s\u00F8ke etter"),
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("a", { href: "/sok?query=9780071244749" }, "ISBN"),
                    ","),
                React.createElement("li", null,
                    React.createElement("a", { href: "/sok?query=Det%20tenkende%20mennesket" }, "bokens navn"),
                    ","),
                React.createElement("li", null,
                    React.createElement("a", { href: "/sok?query=Frank%20M.%20Carrano" }, "forfatterens navn"),
                    ", eller"),
                React.createElement("li", null,
                    React.createElement("a", { href: "/sok?query=matte" }, "tagger"),
                    ".")))));
};
var BookResult = function (_a) {
    var book = _a.book;
    return (React.createElement("li", { className: "object composite search-page__result" },
        React.createElement("section", { className: "object book" },
            React.createElement("div", { className: "book-cover" }, book.imageUrl && React.createElement("img", { src: book.imageUrl, alt: book.title })),
            React.createElement("h2", null,
                React.createElement("a", { href: "/bok/" + book.isbn }, book.title)),
            React.createElement("p", null, formatMetadata(book))),
        React.createElement("div", { className: "object search-result" },
            React.createElement("strong", { className: "price" + (book.lowestPrice === null || book.lowestPrice === undefined ? ' placeholder' : '') }, formatPrice(book.lowestPrice)),
            React.createElement("span", { className: "columns" },
                React.createElement("a", { href: "/bok/" + book.isbn, className: "button" }, "Kj\u00F8p"),
                React.createElement("a", { href: "/sett_inn_annonse?isbn=" + book.isbn, className: "button orange-color" }, "Selg")))));
};
var SearchPage = function () {
    var query = getSearchQuery();
    var page = getPage();
    var trimmedQuery = query.trim();
    var _a = React.useState(null), response = _a[0], setResponse = _a[1];
    var _b = React.useState(false), missingSaved = _b[0], setMissingSaved = _b[1];
    var _c = React.useState(trimmedQuery.length >= 3), isLoading = _c[0], setIsLoading = _c[1];
    var _d = React.useState(null), error = _d[0], setError = _d[1];
    React.useEffect(function () {
        var isMounted = true;
        var isRedirecting = false;
        setResponse(null);
        setError(null);
        setMissingSaved(false);
        if (trimmedQuery.length < 3) {
            setIsLoading(false);
            return function () {
                isMounted = false;
            };
        }
        setIsLoading(true);
        searchBooks(trimmedQuery, page * SEARCH_LIMIT, SEARCH_LIMIT)
            .then(function (nextResponse) { return __awaiter(void 0, void 0, void 0, function () {
            var nextMissingSaved, importedBook;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (nextResponse.results.length === 1) {
                            isRedirecting = true;
                            window.location.href = "/bok/" + nextResponse.results[0].isbn;
                            return [2 /*return*/];
                        }
                        nextMissingSaved = false;
                        if (!(nextResponse.results.length === 0 && page === 0 && isMissingBookCandidate(trimmedQuery))) return [3 /*break*/, 3];
                        return [4 /*yield*/, getBook(stripIsbn(trimmedQuery)).catch(function () { return null; })];
                    case 1:
                        importedBook = _a.sent();
                        if (importedBook && importedBook.isbn) {
                            isRedirecting = true;
                            window.location.href = "/bok/" + importedBook.isbn;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, submitMissingBook(stripIsbn(trimmedQuery))
                                .then(function () { return true; })
                                .catch(function () { return false; })];
                    case 2:
                        nextMissingSaved = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setResponse(nextResponse);
                        setMissingSaved(nextMissingSaved);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function () {
            if (isMounted) {
                setError('Kunne ikke hente søkeresultater. Prøv igjen om litt.');
            }
        })
            .finally(function () {
            if (isMounted && !isRedirecting) {
                setIsLoading(false);
            }
        });
        return function () {
            isMounted = false;
        };
    }, [page, trimmedQuery]);
    if (trimmedQuery.length < 3) {
        return React.createElement(SearchTips, { query: query, tooShort: !!trimmedQuery });
    }
    if (isLoading) {
        return React.createElement("div", { className: "main-content search-page__status" },
            React.createElement("h1", null,
                "S\u00F8ker etter '",
                trimmedQuery,
                "'"));
    }
    if (error) {
        return React.createElement("div", { className: "main-content search-page__status", role: "alert" },
            React.createElement("h1", null, "S\u00F8k feilet"),
            React.createElement("p", null, error));
    }
    if (!response || response.results.length === 0) {
        return React.createElement(SearchTips, { query: trimmedQuery, missingSaved: missingSaved });
    }
    var metadata = response.metadata, results = response.results;
    var hasPrevious = metadata.offset > 0;
    var hasNext = metadata.offset + results.length < metadata.total;
    return React.createElement("div", { className: "main-content search-page" },
        React.createElement("h1", { className: "medium" },
            "S\u00F8k: '",
            trimmedQuery,
            "'"),
        React.createElement("ul", { className: "search-page__results" }, results.map(function (book) { return React.createElement(BookResult, { key: book.isbn, book: book }); })),
        React.createElement("nav", { className: "search-page__pagination", "aria-label": "Sider" },
            hasPrevious && React.createElement("a", { href: getSearchPath(trimmedQuery, Math.max(0, page - 1)), className: "button" }, "Forrige side"),
            hasNext && React.createElement("a", { href: getSearchPath(trimmedQuery, page + 1), className: "button" }, "Neste side")));
};
export default SearchPage;
